import { Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { BetslipBetBuilderPick } from '../../../core/picks/betslip-bet-builder-pick';
import { BetslipOverAskPickBaseComponent } from './betslip-over-ask-pick-base.component';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPickBetBuilderBaseComponent extends BetslipOverAskPickBaseComponent {
    constructor(siteCore: Sitecore) {
        super(siteCore);
    }

    get pick(): BetslipBetBuilderPick {
        return this.props.overAskPick.pick as BetslipBetBuilderPick;
    }

    messages: {
        betBuilderMarketName: string;
    };
}
